<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container>
      <base-material-card
        icon="mdi-clipboard-text-outline"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("planner.title") }}
            <legend-tool :list="legendList"></legend-tool>
          </div>
        </template>
        <v-speed-dial
          v-model="fab"
          absolute=""
          top
          v-if="$store.getters['auth/userWrite']"
          right
          direction="left"
          :open-on-hover="true"
          transition="slide-x-transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="primary" dark fab>
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  $router.push({
                    name: 'New/RecurringTask',
                    params: { equipId: $route.params.id, type: 'recurrent' }
                  })
                "
                fab
                v-bind="attrs"
                v-on="on"
                small
                dark
                color="info"
                ><v-icon color="white">mdi-repeat</v-icon></v-btn
              >
            </template>
            <span>{{ $t("planner.buttons.newRecurrentTask") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  $router.push({
                    name: 'New/RecurringTask',
                    params: { equipId: $route.params.id, type: 'unique' }
                  })
                "
                fab
                v-bind="attrs"
                v-on="on"
                small
                dark
                color="secondary"
                ><v-icon color="white">mdi-repeat-once </v-icon></v-btn
              >
            </template>
            <span>{{ $t("planner.buttons.newOnetimeTask") }}</span>
          </v-tooltip>
        </v-speed-dial>

        <!-- Filtros -->
        <form>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                :label="$t('planner.labels.search')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('planner.labels.maintenance')"
                color="pmaintenance"
                value="maintenance"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('planner.labels.reliability')"
                color="preliability"
                value="reliability"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('planner.labels.repair')"
                color="prepair"
                value="repair"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('planner.labels.onetimeTask')"
                color="secondary"
                value="unique"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('planner.labels.recurrentTask')"
                color="info"
                value="recurrent"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </form>
        <!-- ! Aquí deben ir los tabs controllers -->
        <v-tabs
          v-model="tab"
          :color="$vuetify.theme.isDark ? 'white' : 'primary'"
          background-color="transparent"
          grow
        >
          <v-tab>
            {{ $t("planner.tabs.todo") }}
          </v-tab>
          <v-tab>
            {{ $t("planner.tabs.history") }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-container>
              <v-row v-if="groupedRealTaskList.length > 0">
                <work-day
                  v-for="days in groupedRealTaskList"
                  :key="days.date"
                  :date="days.date"
                  :events="days.events"
                  :history="false"
                  @doneTask="validatingRepair"
                  @deleteOneTask="deleteOneTask"
                  @disableTask="disableTask"
                >
                </work-day>
              </v-row>
              <v-row v-else>
                <task :task="todayTaskSample"></task>
              </v-row>
            </v-container>
          </v-tab-item>
          <!-- ! Aquí debe ir el historial -->
          <v-tab-item>
            <v-container>
              <v-row v-if="historyList.length > 0">
                <work-day
                  v-for="days in groupedHistoryList"
                  :key="days.date"
                  :date="days.date"
                  :events="days.events"
                  :history="true"
                  @doneTask="doneTask"
                  @deleteOneTask="deleteOneTask"
                  @disableTask="disableTask"
                >
                </work-day>
              </v-row>
              <v-row v-else>
                {{ $t("planner.messages.notasks") }}
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>

        <!-- Modal for repair log or details -->
        <v-dialog persistent max-width="350px" v-model="modalRepair">
          <v-card>
            <v-card-title>{{ $t("planner.messages.changelog") }}</v-card-title>
            <v-card-text>
              <v-text-field v-model="repairLogDescription"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn dark @click="doneTask(temporalTask, temporalDate, true)">
                Ok
              </v-btn>
              <v-btn dark @click="doneTask(temporalTask, temporalDate)">
                No
              </v-btn>
              <v-btn dark @click="modalRepair = false">
                {{ $t("planner.buttons.cancel") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </base-material-card>
    </v-container></v-container
  >
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/plugins/db";
import lodash from "lodash";
export default {
  components: {
    WorkDay: () => import("./WorkDay"),
    task: () => import("./Task"),
    legendTool: () => import("@/components/LegendTool")
  },
  data() {
    return {
      tab: null,
      fab: false,
      search: "",
      selectedFilters: [
        "repair",
        "maintenance",
        "reliability",
        "unique",
        "recurrent"
      ],
      colorChips: {
        CREATED: "success",
        UPDATE: "blue",
        REPAIR: "primary"
      },
      todayTaskSample: {
        id: "TODAY",
        taskDate: new Date(),
        showHeader: true
      },
      headers: [
        {
          text: this.$t("repairList.type"),
          value: "type"
        },
        {
          text: "Task Name",
          value: "taskName"
        },
        {
          text: this.$t("repairList.log"),
          value: "log"
        },
        { text: this.$t("repairList.repairDate"), value: "dateCreated" }
      ],
      colors: {
        green: "#008450",
        yellow: "#EFB700",
        red: "#B81D13"
      },
      timeObject: [
        ["year", 31536000],
        ["month", 2592000],
        ["week", 86400 * 7],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60],
        ["second", 1]
      ],
      legendList: [
        {
          title: "Overdue",
          color: "#B81D13"
        },
        {
          title: "To Expire",
          color: "#EFB700"
        },
        {
          title: "On Time",
          color: "#008450"
        }
      ],
      modalRepair: false,
      temporalTask: null,
      temporalDate: null,
      repairLogDescription: ""
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "calendar/bindEquipmentEvents",
      this.$route.params.id
    );

    loading.close();
  },
  computed: {
    ...mapState("calendar", ["events"]),
    ...mapState("auth", ["user"]),
    realTaskList() {
      if (this.events) {
        let realList = [];

        const todayTaskSample = {
          id: "TODAY",
          taskDate: this.getSimpleDate(new Date())
        };

        realList.push(todayTaskSample);

        const today = new Date();
        this.events.forEach(task => {
          // Unique
          if (task.type === "unique" && !task.isDone) {
            realList.push({
              id: task.id,
              name: task.name,
              type: task.type,
              subtype: task.subtype,
              taskDate: task.start,
              description: task.description || task.details,
              lastTime: task.lastChange,
              changeTime: task.changeTime,
              alertTime: task.alertTime,
              disabledArray: task.disabledArray
            });
          }

          //Recurrent
          if (task.type === "recurrent" && !task.isDone) {
            const startMiliseconds = +new Date(task.start);

            const sixMonths = 6 * 30 * 24 * 3600 * 1000;
            const finalTime = +today + sixMonths;
            let dateToEvent = +startMiliseconds;
            while (dateToEvent < finalTime) {
              // Si es evento recurrente con eventos eliminados

              const uniqueId = `${task.id}${dateToEvent}`;
              if (!task.disabledArray?.includes(uniqueId)) {
                const taskDate = this.getSimpleDate(dateToEvent);

                realList.push({
                  id: task.id,
                  uniqueId,
                  name: task.name,
                  type: task.type,
                  subtype: task.subtype,
                  taskDate,
                  description: task.description || task.details,
                  lastTime: task.lastChange,
                  changeTime: task.changeTime,
                  alertTime: task.alertTime,
                  disabledArray: task.disabledArray
                });
              }
              dateToEvent += task.changeTime * 1000;
            }
          }
        });
        return realList;
      }
      return [];
    },
    filteredRealTaskList() {
      if (this.realTaskList) {
        return this.realTaskList.filter(task => {
          const isToday = task.id === "TODAY";
          const isInFilters =
            this.selectedFilters.includes(task.type) &&
            this.selectedFilters.includes(task.subtype);

          const isInSearch =
            task?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.description
              ?.toLowerCase()
              .includes(this.search.toLowerCase());

          return isToday || (isInSearch && isInFilters);
        });
      }
      return [];
    },
    groupedRealTaskList() {
      if (this.filteredRealTaskList) {
        const objectByDate = lodash.groupBy(
          this.filteredRealTaskList,
          "taskDate"
        );

        const arrayByDate = Object.entries(objectByDate).map(
          ([date, events]) => ({
            date,
            events
          })
        );

        arrayByDate.sort(function(dayA, dayB) {
          return dayA.date < dayB.date ? -1 : 1;
        });

        return arrayByDate;
      }
      return [];
    },
    historyList() {
      if (this.events) {
        let realList = [];

        this.events.forEach(task => {
          // Unique
          if (task.type === "unique" && task.isDone) {
            realList.push({
              id: task.id,
              name: task.name,
              type: task.type,
              subtype: task.subtype,
              taskDate: task.start,
              description: task.description || task.details,
              lastTime: task.lastChange,
              changeTime: task.changeTime,
              alertTime: task.alertTime,
              disabledArray: task.disabledArray
            });
          }
        });
        return realList;
      }
      return [];
    },
    filteredHistoryList() {
      return this.historyList.filter(task => {
        const isToday = task.id === "TODAY";
        const isInFilters =
          this.selectedFilters.includes(task.type) &&
          this.selectedFilters.includes(task.subtype);

        const isInSearch =
          task?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.description?.toLowerCase().includes(this.search.toLowerCase());

        return isToday || (isInSearch && isInFilters);
      });
    },
    groupedHistoryList() {
      if (this.filteredHistoryList) {
        const objectByDate = lodash.groupBy(
          this.filteredHistoryList,
          "taskDate"
        );

        const arrayByDate = Object.entries(objectByDate).map(
          ([date, events]) => ({
            date,
            events
          })
        );

        arrayByDate.sort(function(dayA, dayB) {
          return dayA.date > dayB.date ? -1 : 1;
        });

        return arrayByDate;
      }
      return [];
    }
  },
  methods: {
    tryConsole(something) {
      console.log(something);
    },
    getSimpleDate(date) {
      const jsDate = new Date(date);
      const year = jsDate.getFullYear();
      const month =
        jsDate.getMonth() + 1 >= 10
          ? jsDate.getMonth() + 1
          : `0${jsDate.getMonth() + 1}`;
      const day =
        jsDate.getDate() >= 10 ? jsDate.getDate() : `0${jsDate.getDate()}`;

      return `${year}-${month}-${day}`;
    },
    validatingRepair(task, selectedDate = null) {
      if (task.subtype === "repair") {
        this.temporalTask = { ...task };
        this.temporalDate = selectedDate;
        this.repairLogDescription = task.description;
        this.modalRepair = true;
      } else {
        this.doneTask(task, selectedDate);
      }
    },
    doneTask: async function(task, selectedDate = null, isRepair = false) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });

      const { type, uniqueId = "", disabledArray = [] } = task;

      const today = new Date().toISOString().substr(0, 10);

      if (type === "unique" && !isRepair) {
        try {
          await db
            .collection("calendar")
            .doc(task.id)
            .update({
              isDone: true,
              start: selectedDate ? selectedDate : today
            });
        } catch (err) {
          console.error(err);
        }
      }
      if (type === "unique" && isRepair) {
        try {
          await db
            .collection("calendar")
            .doc(task.id)
            .update({
              isDone: true,
              start: selectedDate ? selectedDate : today,
              description: this.repairLogDescription,
              details: this.repairLogDescription
            });
        } catch (err) {
          console.error(err);
        }
      }
      if (type === "recurrent") {
        let newDisabledList = [...disabledArray, uniqueId];
        let cloneTask = this.events.find(event => event.id === task.id);

        // * Cloning the event to crear a historical regiter
        let payload = {
          db: "calendar",
          data: {
            ...cloneTask,
            equipmentProfile: db
              .collection("equipments")
              .doc(cloneTask.equipmentProfile.id),
            start: selectedDate ? selectedDate : today,
            end: selectedDate ? selectedDate : today,
            lastChange: selectedDate ? selectedDate : today,
            disabledArray: [],
            uniqueId: task.uniqueId,
            isDone: true,
            type: "unique",
            description: isRepair
              ? this.repairLogDescription
              : cloneTask?.description || cloneTask?.details,
            details: isRepair
              ? this.repairLogDescription
              : cloneTask?.description || cloneTask?.details
          }
        };

        try {
          // * Updating the existing event to disabled the done one
          await db
            .collection("calendar")
            .doc(task.id)
            .update({ disabledArray: [...newDisabledList] });

          // * Creating the historical register
          await this.$store.dispatch("addDocument", payload);
        } catch (err) {
          console.error(err);
        }
      }

      this.modalRepair = false;

      this.$dialog.notify.success("Your task has been updated", {
        position: "top-right",
        timeout: 5000
      });

      loading.close();
    },
    deleteOneTask: async function(task) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });

      const { type, uniqueId = "", disabledList = [] } = task;

      if (type === "recurrent") {
        let newDisabledList = [...disabledList, uniqueId];
        try {
          await db
            .collection("calendar")
            .doc(task.id)
            .update({ disabledArray: [...newDisabledList] });
        } catch (error) {
          console.error(error);
        }
      }

      if (type === "unique") {
        try {
          await db
            .collection("calendar")
            .doc(task.id)
            .update({ disabled: true });
        } catch (error) {
          console.error(error);
        }
      }

      this.$dialog.notify.success("Your task has been updated", {
        position: "top-right",
        timeout: 5000
      });
      loading.close();
    },
    disableTask: async function(task) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });

      try {
        await db
          .collection("calendar")
          .doc(task.id)
          .update({ disabled: true });
      } catch (error) {
        console.error(error);
      }

      this.$dialog.notify.success("Your task has been updated", {
        position: "top-right",
        timeout: 5000
      });
      loading.close();
    }
  }
};
</script>
